<template>
    <el-select
        v-model="innerValue"
        @change="langChange"
        class="select-wrapper"
        :placeholder="placeholder"
        :filterable="!!filterable"
        :disabled="disabled"
        :multiple="!!multiple"
        :valueKey="valueKey"
    >
        <el-option v-for="item in innerOptions"
            :key="typeof item.value == 'object' ? item.value[valueKey] : item.value"
            :label="item.label"
            :value="item.value" />
    </el-select>
</template>

<script>
export default {
    name: "Select",
    model: {
        props: "value",
        event: "change"
    },
    props: ["value", "options", "multiple", "filterable", "placeholder", "disabled", "valueKey", "remoteMethod", "styles"],
    data() {
        return {
            innerValue: this.value,
            innerOptions: this.options,
        };
    },
    watch: {
        value(val) {
            this.innerValue = val;
        },
        options() {
            this.innerOptions = this.options;
        },
    },
    async created() {
        if (this.remoteMethod) {
            const options = await this.remoteMethod();
            this.innerOptions = options;
            if (this.value) {
                options.some((option) => {
                    if (option.value === this.value || option.value.value === this.value.value) {
                        this.innerValue = option.value;
                        this.$emit("init", this.innerValue);
                        return true;
                    }
                    return false;
                });
            }
        }
    },
    methods: {
        langChange() {
            this.$emit("change", this.innerValue);
        },
    },
};
</script>

<style scoped>
.select-wrapper {
    width: 100%;
}
</style>
